<template>
  <img
    @mouseover="copyIconImg = copyIconActive"
    @mouseleave="copyIconImg = copyIcon"
    :src="copyIconImg"
    @click="_doCopy"
  />
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import withToasted from "@/mixins/withToasted";

import copyIcon from "@/assets/images/context-menu/copy.svg";
import copyIconActive from "@/assets/images/context-menu/copy-active.svg";

export default Vue.component("VCopyIcon", {
  props: {
    copyText: VueTypes.string,
    showTooltip: VueTypes.bool.def(true)
  },

  data() {
    return {
      copyIcon,
      copyIconActive,
      copyIconImg: copyIcon
    };
  },

  mixins: [withToasted],

  methods: {
    _doCopy: function() {
      this.$copyText(this.copyText).then(
        () => {
          if (this.showTooltip) {
            this.toast("Copied!", "success", { icon: "check" });
          }
        },
        () => {
          if (this.showTooltip) {
            this.toast("Something went wrong!", "error", { icon: "times" });
          }
        }
      );
    }
  }
});
</script>

<style lang="scss" scoped>
img {
  cursor: pointer;
}
</style>
